export const baseFetch = async (
    url: string,
    options: RequestInit,
    responseType: 'json' | 'raw' = 'json'
) => {
    try {
        const isFormData = options.body instanceof FormData;

        const config: RequestInit = {
            ...options,
            headers: {
                ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
                'X-Requested-With': 'XMLHttpRequest',
                ...options.headers,
            },
            credentials: 'include',
        };

        const response = await fetch(url, config);

        if (!response.ok) {
            const error = new Error(`HTTP ${response.status}: ${response.statusText}`) as Error & {
                httpStatus?: number;
            };
            if (
                Number.isInteger(response.status) &&
                response.status >= 100 &&
                response.status <= 599
            ) {
                error.httpStatus = response.status;
            }
            throw error;
        }

        if (responseType === 'json') {
            // Handle cases where response body might be empty or whitespace-only
            const text = await response.text();
            return text.trim() ? JSON.parse(text) : {};
        }

        return response;
    } catch (error) {
        throw error;
    }
};
